export const passwordStrengthLevel = (password) => {
  let score = 0;
  // let strength = '';
  let regexPositives = [
    "[A-ZÑ]",
    "[a-zñ]",
    "[0-9]",
    "^[A-ZÑa-zñ0-9]{8,30}$",
  ];

  let levels = {
    DEFAULT: '',
    WEAK: 'weak',
    MEDIUM: 'medium',
    STRONG: 'strong',
  };

  regexPositives.forEach(regex => {
    if (new RegExp(regex).test(password)) {
      score += 1;
    }
  });

  switch (score) {
    case 1:
      return levels.WEAK;
    case 2:
    case 3:
      return levels.MEDIUM;
    case 4:
      return levels.STRONG;
    default:
      return levels.DEFAULT;
  }
}